// M144a (2026-05-12): FE permission helper cho role 'manager'.
//
// Pattern dùng:
//   import { hasPermission } from '../lib/permissions.js';
//   const { user } = useAuthStore();
//   if (!hasPermission(user, 'progress')) return <NotAuthorized />;
//
// Filter menu cards:
//   const cards = ALL_CARDS.filter(c => hasPermission(user, c.permKey));

/**
 * Check user có permission key này không.
 * - admin → luôn true (full quyền)
 * - manager → check user.permissions array
 * - kiosk/null → false (không vào /admin)
 */
export function hasPermission(user, permKey) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (user.role !== 'manager') return false;
  if (!Array.isArray(user.permissions)) return false;
  return user.permissions.includes(permKey);
}

/**
 * Check user có quyền vào trang admin nói chung (admin hoặc manager).
 */
export function canAccessAdmin(user) {
  return user?.role === 'admin' || user?.role === 'manager';
}
